import { enContent } from './en';
import { arContent } from './ar';
import { cookies, getCookie } from "../constants/constants";
import { Language } from "../../../middlewares/language";

export const staticContent = (getCookie(cookies.lang) == Language.ARABIC) ? arContent : enContent;